import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: {},
    products: [],
    hazards: [],
    vendors: [],
    manufacturers: [],
    locations: [],
    types: []
  },
  mutations: {
    INIT_STORE(state, store) {
      this.replaceState(Object.assign(state, store));
    },
    SET_AUTH(state, data) {
      state.auth = data;
    },
    UPDATE_AUTH_TOKEN(state, token) {
      state.auth.token = token;
    },
    SET_PRODUCTS(state, data) {
      state.products = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("SET_AUTH", data);
      return data;
    },
    set_products({ commit }, data) {
      commit("SET_PRODUCTS", data);
    }
  },
  getters: {
    products: state => {
      return state.products;
    },
    token: state => {
      try {
        return JSON.parse(atob(state.auth.token.split(".")[1]));
      } catch (e) {
        return null;
      }
    },
    isTokenValid: (state, getters) => () => {
      try {
        const now = new Date() / 1000;
        const exp = getters.token.exp;
        return exp > now;
      } catch (e) {
        return null;
      }
    },
    isAdmin: (state, getters) => () => {
      try {
        return getters.isTokenValid() && state.auth.user.is_admin;
      } catch (e) {
        return null;
      }
    }
  },
  modules: {}
});
